import styled from 'styled-components';

import { theme } from '../../../../styles/styled';

export const MetaDataTable = styled.table`
  margin: 0.25em;
  word-break: break-word;

  th,
  td {
    font-size: 0.75em;
    padding: 0.2em 0;
  }
  th {
    width: 6.25em;
    font-weight: ${theme.constant.pageTitle.fontWeight};
    text-align: left;
  }
`;

export const CopyButton = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  padding: 4px;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
`;

export const CopyIcon = styled.span`
  width: 12px;
  height: 12px;
`;

export const AssetDetailsLink = styled.span`
  display: inline-flex;
  align-items: center;
`;

export const AssetDetailsText = styled.span`
  text-decoration: underline;
`;

export const ShareIcon = styled.span`
  width: 8px;
  margin-left: 2px;
`;
